module.exports = [
  { id: '54', abbreviation: 'AB', value: 'Alberta' },
  { id: '55', abbreviation: 'BC', value: 'Columbie-Britannique' },
  { id: '56', abbreviation: 'MB', value: 'Manitoba' },
  { id: '57', abbreviation: 'NB', value: 'Nouveau-Brunswick' },
  { id: '58', abbreviation: 'NL', value: 'Terre-Neuve' },
  { id: '59', abbreviation: 'NT', value: 'Territoire du N.-O.' },
  { id: '60', abbreviation: 'NS', value: 'Nouvelle-Écosse' },
  { id: '61', abbreviation: 'NU', value: 'Nunavut' },
  { id: '62', abbreviation: 'ON', value: 'Ontario' },
  { id: '63', abbreviation: 'PE', value: 'Î.-P.-É.' },
  { id: '111', abbreviation: 'QC', value: 'Québec' },
  { id: '112', abbreviation: 'SK', value: 'Saskatchewan' },
  { id: '113', abbreviation: 'YT', value: 'Yukon' },
];
